import ReactDOM from "react-dom/client";
import "./i18n";
import "./index.min.css";
import "./tailwind.css";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));

// ✅ SERVICE WORKER (version clean)
if ("serviceWorker" in navigator && !window.__PRERENDER__) {
  window.addEventListener("load", async () => {
    try {
      const reg = await navigator.serviceWorker.register("/sw.js");
      console.log("✅ SW enregistré :", reg);
    } catch (err) {
      console.error("❌ SW erreur :", err);
    }
  });
}

root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

reportWebVitals();
